import './WorkImpactCard.css';
import CountUpValue from '../CountUpValue/CountUpValue';
import { getImageSrc } from '../../utils/imageUtils';

export default function WorkImpactCard({
  metrics = [],
  workshops = [],
  className = '',
  title,
  showWorkshops = false,
}) {
  const classes = [
    'WorkImpactCard',
    title ? 'WorkImpactCard--withTitle' : '',
    showWorkshops ? 'WorkImpactCard--workshops' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  const fallbackLogo = getImageSrc('people_default.png');

  return (
    <div className={classes}>
      <div className="WorkImpactCard__metrics">
        {title ? <div className="WorkImpactCard__title">{title}</div> : null}
        {showWorkshops ? (
          <div className="WorkImpactCard__workshops" role="list">
            {workshops.map((workshop, index) => {
              const imageSrc = getImageSrc(workshop.logo_url, { fallback: fallbackLogo });
              const imageAlt = workshop.name ? `${workshop.name} logo` : 'Workshop logo';
              return (
                <div
                  key={`${workshop.name || 'workshop'}-${index}`}
                  className="WorkImpactCard__workshop"
                  role="listitem"
                >
                  <div className="WorkImpactCard__workshopLogoWrap">
                    <img
                      className="WorkImpactCard__workshopLogo"
                      src={imageSrc}
                      alt={imageAlt}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  {workshop.name ? (
                    <div className="WorkImpactCard__workshopName">{workshop.name}</div>
                  ) : null}
                </div>
              );
            })}
          </div>
        ) : (
          metrics.map((metric) => (
            <div key={metric.label} className="WorkImpactCard__metric">
              <CountUpValue className="WorkImpactCard__metricValue" value={metric.value} />
              <div className="WorkImpactCard__metricLabel">{metric.label}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
